/** @format */

import * as documentsTypes from './documentsTypes';
import {
  uploadDocsService,
  fetchClientsService,
  fetchDocTypesService,
  fetchEmployeesService,
  openDocumentAPI,
  deleteDocumentAPI,
  getDocumentDetailsAPI,
  fetchDocFieldsService,
  getFiltersAPI,
  applyFiltersAPI,
  getDocumentsAPI,
  saveDocUploadService,
  getDocumentGroupService,
  getCaseManagerIdService,
  setDocumentReceivedService,
  setAcknowledgeDocumentService,
  getSupportedFileTypes,
  fetchRequestDocTypesService,
  saveOtherRequiredDocuments,
  getSLADetailService,
  getSLAListService,
  getDeliveryReturnIRCounterService,
  missingDocumentsAPI,
  allDocsReceivedByEYAPI,
  saveOverrideExternalSLAService,
  downloadZipAllDocuments,
  generateExecuteSPAPI,
  setUploadStatusService,
  getLinkedCasesAPI,
  startResumeButton,
  setSurePrepOCRChangeService,
  openDocumentAPIfromGlobalMenu
} from 'src/services/documents.service';
import { showNotification } from 'src/utils/utilsActions';
import download from 'downloadjs';
import mime from 'mime-types';
import { getCasesPending } from 'src/ui/features/Cases/state/casesActions';
import intl from 'react-intl-universal';
export const getDownloadZipDocuments = caseManagerId => {
  return async dispatch => {
    await downloadZipAllDocuments(caseManagerId)
      .then(res => {
        if (res.success === true) {
          dispatch(getZipDownloadSucess(res));
          dispatch(showNotification('Zip Documents Created Successfully', { variant: 'success' }));
        } else {
          throw new Error('Error');
        }
      })
      .catch(err => {
        console.error(err);
        dispatch(showNotification('No files available!', { variant: 'error' }));
      });
  };
};

export const getZipDownloadSucess = payload => ({
  type: documentsTypes.ZIP_DOCUMENTS_SUCCESS,
  payload,
});

export const getExecuteSPAPI = () => {
  return async dispatch => {
    await generateExecuteSPAPI()
      .then(res => {
        if (res.success === true) {
          dispatch(getExecuteSPAPISuccess(res));
          dispatch(showNotification(res.message, { variant: 'success' }));
        } else {
          throw new Error('Error');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getExecuteSPAPISuccess = payload => ({
  type: documentsTypes.EXECUTE_SP_API_SUCCESS,
  payload,
});

export const getDocumentsSuccess = payload => {
  return dispatch => {
    dispatch({
      type: documentsTypes.GET_DOCUMENTS_SUCCESS,
      payload,
    });
  };
};

export const getlinkedCaseSuccess = payload => {
  return dispatch => {
    dispatch({
      type: documentsTypes.GET_LINKEDCASE_SUCCESS,
      payload,
    });
  };
};

export const hydrateDocuments = payload => ({
  type: documentsTypes.HYDRATE_DOCUMENTS,
  payload,
});

export const getDocuments = (params, config) => {
  return async (dispatch, getState) => {
    let paramsOptions = params;
    const { documents } = getState();
    if (documents.appliedFilters) {
      paramsOptions = {
        ...documents.appliedFilters,
        ...params,
      };
    }
    if (params.isCase) {
      paramsOptions.clientId = undefined;
      paramsOptions.countryId = undefined;
      paramsOptions.yearId = undefined;
      paramsOptions.CasePhaseId = undefined;
      paramsOptions.caseContactEmailId = undefined;
      paramsOptions.addedDocsAfterAllDocsSubmitted = undefined;
    }
    await getDocumentsAPI(paramsOptions, config)
      .then(res => {
        if (res) {
          if (res.success === true) {
            dispatch(getDocumentsSuccess(res));
            dispatch(incrementDocCount(res.total));
          } else if (res.success === false) {
            dispatch(showNotification(res.error.message, { variant: 'error' }));
          } else {
            throw new Error('Error');
          }
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getlinkedCases = (params, config) => {
  return async (dispatch, getState) => {
    const res = {};
    if (res.success === true) {
      dispatch(getlinkedCaseSuccess(res));
    }

    await getLinkedCasesAPI(params, config)
      .then(res => {
        if (res) {
          if (res.success === true) {
            dispatch(getlinkedCaseSuccess(res));
          } else {
            throw new Error('Error');
          }
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getDocumentsFailure = error => ({
  type: documentsTypes.GET_DOCUMENTS_FAILURE,
  error,
});

export const getDeliveryReturnIRCounter = params => {
  return async dispatch => {
    await getDeliveryReturnIRCounterService(params).then(res => {
      if (res.success === true) {
        let getIRCounter = {
          IRCounter: res.messages,
        };
        dispatch(getIRCounterSuccess(getIRCounter));
      } else if (res.success === false) {
        let getIRCounter = {
          IRCounter: res.error.message,
        };
        dispatch(getIRCounterfails(getIRCounter));
      }
    });
  };
};

export const getIRCounterSuccess = payload => ({
  type: documentsTypes.GET_IR_COUNTER,
  payload,
});

export const getIRCounterfails = payload => ({
  type: documentsTypes.GET_IR_COUNTER,
  payload,
});

export const getSupportedFileTypesdocuments = applicantId => {
  return async dispatch => {
    const { ...response } = await getSupportedFileTypes(applicantId);
    let getsupportFileType = {
      fileSupport: response.supportedfileTypes,
    };
    dispatch(getFileTypeSuccess(getsupportFileType));
  };
};

export const getFileTypeSuccess = payload => ({
  type: documentsTypes.GET_SUPPORT_FILE,
  payload,
});

export const getFilters = config => {
  return async dispatch => {
    await getFiltersAPI(config)
      .then(res => {
        if (res.success === true) {
          dispatch(hydrateDocumentsFilters(res.filters));
        } else {
          throw new Error('Error');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getSlaDetails = (caseManagerId, SLA2Override) => {
  return async dispatch => {
    await getSLADetailService(caseManagerId, SLA2Override)
      .then(res => {
        if (res.success === true) {
          dispatch(slaDocumentDetails(res.messages));
        } else {
          throw new Error('Error');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const slaDocumentDetails = (data = {}) => ({
  type: documentsTypes.GET_SLA_DOCUMENT_DETAILS,
  data,
});

export const getslalist = () => {
  return async dispatch => {
    await getSLAListService().then(res => {
      if (res.success === true) {
        dispatch(slalist(res.typeofSLA));
      }
    });
  };
};

export const slalist = (data = {}) => ({
  type: documentsTypes.GET_SLA_LIST,
  data,
});

export const setMissingDocuments = params => {
  return async dispatch => {
    await missingDocumentsAPI(params);
  };
};

export const setAllDocsReceivedByEY = params => {
  return async dispatch => {
    await allDocsReceivedByEYAPI(params);
  };
};

export const setSurePrepOCRChange = params => {
  return async dispatch => {
    await setSurePrepOCRChangeService(params);
  };
}

export const saveOverrideExternalSLA = (caseManagerId, OverrideExternalSLADate) => {
  return async dispatch => {
    await saveOverrideExternalSLAService(caseManagerId, OverrideExternalSLADate);
  };
};

export const appliedDocumentFilters = filters => ({
  type: documentsTypes.APPLIED_DOCUMENTS_FILTERS,
  filters,
});
export const hydrateDocumentsFilters = filters => ({
  type: documentsTypes.HYDRATE_DOCUMENTS_FILTERS,
  filters,
});

export const applyDocumentFilters = config => {
  return async dispatch => {
    await applyFiltersAPI(config)
      .then(res => {
        if (res.success) {
          dispatch(appliedDocumentFilters(config));
          dispatch(getDocumentsSuccess(res));
        } else {
          throw new Error('Error in applying filters');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

//showModal
export const toggleModal = (status, anchorEl) => ({
  type: documentsTypes.SHOW_FILTER_MODAL,
  status,
  anchorEl,
});

export const getClientsSuccess = (data, index) => ({
  type: documentsTypes.GET_CLIENTS_SUCCESS,
  data,
  index,
});

export const getEmployeesSuccess = (data, index) => ({
  type: documentsTypes.GET_EMPLOYEES_SUCCESS,
  data,
  index,
});

export const getDocTypesSuccess = (data, index) => ({
  type: documentsTypes.GET_DOCUMENT_TYPES_SUCCESS,
  data,
  index,
});

export const getDocFieldsSuccess = (data, index) => ({
  type: documentsTypes.GET_DOCUMENT_FIELDS_SUCCESS,
  data,
  index,
});

export const saveDocSuccess = data => ({
  type: documentsTypes.GET_EMPLOYEES_SUCCESS,
  data,
});

export const resetDocUpload = () => ({
  type: documentsTypes.RESET_DOCUMENT_UPLOAD,
});

export const resetDocFields = index => ({
  type: documentsTypes.RESET_DOCUMENT_FIELDS,
  index,
});

export const getDocFields = (params, index, caseDocumentTypeId) => {
  return async dispatch => {
    const item = await fetchDocFieldsService(params, caseDocumentTypeId);

    if (item) {
      dispatch(resetDocFields(index));
      dispatch(getDocFieldsSuccess(item.message, index));
    }
  };
};

export const getClients = index => {
  return async dispatch => {
    const { success, engagements } = await fetchClientsService();

    if (success) {
      dispatch(getClientsSuccess(engagements, index));
    }
  };
};

// open/download/delete files
export const deleteDocument = (documentId, caseDocumentTypeId, notifText, fetchCallback = () => {}, updateCaseCountCb = () => {}) => {
  return async dispatch => {
    const onFetch = typeof fetchCallback === 'function' ? fetchCallback : () => {};
    const onUpdateCaseCount = typeof updateCaseCountCb === 'function' ? updateCaseCountCb : () => {};

    await deleteDocumentAPI(documentId, caseDocumentTypeId)
      .then(res => {
        // response is undefined when there's an error. Must fix this on the BE.
        if (res && res.success) {
          dispatch(deleteDocumentSuccess(res));
          onUpdateCaseCount();
          onFetch();
          dispatch(showNotificationSuccess(notifText));
        } else {
          throw new Error('Error deleting document.');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const saveDocUpload = (dataArr, notifText, errorText, callback, taxRetCB, docGroupId, isPriceLockPrompt = false) => {
  return async dispatch => {
    if (docGroupId) {
      processUploadDoc(dispatch, dataArr, notifText, errorText, callback, taxRetCB, docGroupId, isPriceLockPrompt);
    } else {
      await getDocumentGroupService()
        .then(async response => {
          if (response && response.success) {
            const { data : {documentGroupList } } = response; 
            const result = documentGroupList.filter(obj => {
              return obj.groupDescription === 'Taxchat EY Pro Documents'; //put this in en json.
            });

            processUploadDoc(dispatch, dataArr, notifText, errorText, callback, taxRetCB, result[0]['documentGroupId'], isPriceLockPrompt);
          } else {
            dispatch(disableDocSubmitServiceSpinner());
            dispatch(showNotification(response.error.message, { variant: 'error' }));
          }
        })
        .catch(err => {
          dispatch(disableDocSubmitServiceSpinner());
          console.error(err);
        });
    }
  };
};

const processUploadDoc = async (dispatch, dataArr, notifText, errorText, callback, taxRetCB, docGroupId, isPriceLockPrompt) => {
  const promises = dataArr.map(async item => {
    if (!item.documentDetails.caseManagerId) {
      const response = await getCaseManagerIdService(item.documentDetails.applicantId);
      if (response && response.success) {
        item.documentDetails.caseManagerId = response.caseManagerId;
      }
    }
    item.documentDetails.documentGroupId = docGroupId;
  
    // fetching overviewid from session
    const caseChat =  JSON.parse(sessionStorage.getItem('caseChat'));
    const headerDetailsObject = sessionStorage.getItem('headerDetails');
    const headerDetails = headerDetailsObject ? JSON.parse(headerDetailsObject) : {};
    const overViewId = !caseChat ? (headerDetails.overViewId || 0) : 0; 
    item.documentDetails.overViewId = overViewId;
    
    // if(item.documentDetails.isConfirmed){
    return saveDocUploadService(item.documentDetails);
    // }else{
    //     return import('./taxDocSample.json');
    // }
  });
  const res = await Promise.all(promises);
  if (res[0].success) {
    dispatch(disableDocSubmitServiceSpinner());
    if (res[0].documentId !== 0) {
      taxRetCB(res[0].documentId);
    } else {
      dispatch(showNotification(notifText, { variant: 'success' }));
      dispatch(resetDocUpload());
      callback();
    }
  } else {
    dispatch(disableDocSubmitServiceSpinner());
    dispatch(showNotification(res[0].error.message, { variant: 'error' }));
    callback();
  }
};

export const uploadOtherRequiredDocs = (caseManagerId, documentTypeId, details, isEditEnabled, caseDocumentTypeId, notifText, errorText, callback) => {
  saveOtherRequiredDocuments(caseManagerId, documentTypeId, details, isEditEnabled, caseDocumentTypeId)
    .then(res => {
      if (res) {
        sessionStorage.removeItem('currentRequestDocumentData');
        showNotification(notifText, { variant: 'success' });
        window.history.back();
      } else {
        showNotification(errorText, { variant: 'error' });
        window.history.back();
      }
    })
    .catch(err => {
      console.error(err);
    });
};

export const showNotificationSuccess = message => ({
  type: documentsTypes.SHOW_DELETE_NOTIFICATION_SUCCESS,
  message,
});

export const hideNotificationSuccess = () => ({
  type: documentsTypes.HIDE_DELETE_NOTIFICATION_SUCCESS,
});

export const getDocTypes = (id, index, docId) => {
  return async dispatch => {
    const response = await fetchDocTypesService(id, index, docId);

    if (response && response.success) {
      dispatch(getDocTypesSuccess(response, index));
    }
  };
};

export const getRequestDocTypes = (id, index) => {
  return async dispatch => {
    const response = await fetchRequestDocTypesService(id, index);
    const {success} = response
    if (success) {
      dispatch(getDocTypesSuccess(response, index));
    }
  };
};

export const getEmployees = (id, index) => {
  return async dispatch => {
    const { success, employees } = await fetchEmployeesService(id);

    if (success) {
      dispatch(getEmployeesSuccess(employees, index));
    }
  };
};

export const deleteDocumentSuccess = payload => ({
  type: documentsTypes.DELETE_DOCUMENTS_SUCCESS,
  payload,
});

export const getlinkedCase = documentId => {
  return async dispatch => {
    let { success, ...response } = await openDocumentAPI(documentId);
    if (success) {
      dispatch(getDocumentSucess(response));
      if (response.documentData) {
        let data = response.documentData;
        let fileName = response.fileName;
        let type = mime.lookup(fileName);
        download(atob(data), fileName, type);
      }
    }
  };
};

export const getDocumentFromGlobalMenu = documentId => {
  return async dispatch => {
    let { success, ...response } = await openDocumentAPIfromGlobalMenu(documentId);
    if (success) {
      dispatch(getDocumentSucess(response));
      if (response.documentData) {
        let data = response.documentData;
        let fileName = response.fileName;
        let type = mime.lookup(fileName);
        download(atob(data), fileName, type);
      }
    }
  };
};


export const getDocument = documentId => {
  return async dispatch => {
    let { success, ...response } = await openDocumentAPI(documentId);
    if (success) {
      dispatch(getDocumentSucess(response));
      if (response.documentData) {
        let data = response.documentData;
        let fileName = response.fileName;
        let type = mime.lookup(fileName);
        download(atob(data), fileName, type);
      }
    }
  };
};

export const setDocumentId = data => ({
  type: documentsTypes.SET_DOCUMENT_ID,
  data,
});

export const uploadDocs = (data, file, isApplicant, isCase, clientId, index, callback, docId, applicantId, caseManagerId=0) => {
  return async dispatch => {
    try {
      const response = await uploadDocsService(data, applicantId, {
        onUploadProgress: progressEvent => {
          if (typeof callback === 'function') {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            callback(percentCompleted);
          }
        },
      }, caseManagerId);
      if (response.success) {
        if (isApplicant || isCase) {
          if (isApplicant) {
            dispatch(
              getCasesPending({
                caseStatusType: 'Open',
                caseType: 'applicantCase',
                pageNumber: 1,
                pageSize: 100,
                filter: true,
              }),
            );
          }

          dispatch(getDocTypes(clientId, index, docId));
        } else {
          dispatch(getClients(index));
        }
        dispatch(setDocumentId({ id: response.documentId, name: response.fileName }));
      } else if (response.success === false) {
        dispatch(getRejectedFileFailure(file));
        dispatch(showNotification(response.error.message, { variant: 'error' }));
      } else {
        dispatch(getRejectedFileFailure(file));
        dispatch(showNotification(intl.get('cases.uploads.errors.uploadFailError'), { variant: 'error' }));
      }
    } catch (err) {
      console.error(err);
      dispatch(getRejectedFileFailure(file));
      dispatch(showNotification(intl.get('cases.uploads.errors.uploadFailError'), { variant: 'error' }));
    }
  };
};

export const resetGetDeletedFile = () => ({
  type: documentsTypes.RESET_DELETEDFILE,
});

export const getRejectedFileFailure = file => ({
  type: documentsTypes.GET_REJECTED_FILE_FAILURE,
  file,
});

export const getDocumentSucess = payload => ({
  type: documentsTypes.OPEN_DOCUMENTS_SUCCESS,
  payload,
});

export const enableServiceSpinner = () => {
  return {
    type: documentsTypes.ENABLE_SERVICE_SPINNER,
  };
};

export const disableServiceSpinner = () => {
  return {
    type: documentsTypes.DISABLE_SERVICE_SPINNER,
  };
};

export const enableDocSubmitServiceSpinner = () => {
  return {
    type: documentsTypes.ENABLE_DOC_SUBMIT_SERVICE_SPINNER,
  };
};

export const disableDocSubmitServiceSpinner = () => {
  return {
    type: documentsTypes.DISABLE_DOC_SUBMIT_SERVICE_SPINNER,
  };
};

export const deleteUploadedDoc = doc => async dispatch => {
  try {
    dispatch(deleteDoc(doc));
  } catch (error) {
    console.log('Error while deleting document');
  }
};

export const deleteDoc = docName => ({
  type: documentsTypes.DELETE_UPLOADED_DOCUMENT,
  docName,
});

export const getDocumentDetails = (documentId, caseDocumentTypeId, callback = () => {}) => {
  return async dispatch => {
    return await getDocumentDetailsAPI(documentId, caseDocumentTypeId)
      .then(res => {
        if (res && res.message.documentInformation) {
          dispatch(hydrateDocumentDetails(res.message));
          return callback();
        } else {
          dispatch(deHydrateDocumentDetails());
          return callback();
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const hydrateDocumentDetails = payload => ({
  type: documentsTypes.HYDRATE_DOCUMENT_DETAILS,
  payload,
});

export const deHydrateDocumentDetails = () => ({
  type: documentsTypes.DEHYDRATE_DOCUMENT_DETAILS,
});

export const storeCaseManagerId = id => ({
  type: documentsTypes.STORE_CASEMANAGER_ID,
  payload: id,
});

export const openDocumentsTab = (payload = true) => ({
  type: documentsTypes.OPEN_DOCS_TAB,
  payload,
});

export const incrementDocCount = count => ({
  type: documentsTypes.INCREMENT_DOC_COUNT,
  payload: count,
});

export const setUploadStatus = (uploadStatusValue,origRowIndex,data) => {
  return async dispatch => {
    let { success } = await setUploadStatusService({
      caseManagerId: data[origRowIndex].caseManagerId,
      caseDocumentTypeId: data[origRowIndex].caseDocumentTypeId,
      documentTypeId: data[origRowIndex].documentTypeId,
      uploadStatus: uploadStatusValue,
      markAsReceived: true,
    });
    if (success) {
      dispatch(setUploadStatusSuccess(data, uploadStatusValue,origRowIndex));
    }
  };
};
export const setDocumentReceived = (data, isChecked, origRowIndex) => {
  return async dispatch => {
    let { success } = await setDocumentReceivedService({
      caseManagerId: data[origRowIndex].caseManagerId,
      caseDocumentTypeId: data[origRowIndex].caseDocumentTypeId,
      documentTypeId: data[origRowIndex].documentTypeId,
      markAsReceived: isChecked,
      uploadStatus: 0,
    });

    if (success) {
      dispatch(setDocumentReceivedSucess(data, isChecked,origRowIndex));
    }
  };
};

export const setUploadStatusSuccess = (payload, uploadStatus,origRowIndex) => ({
  type: documentsTypes.UPDATE_UPLOAD_STATUS,
  payload,
  uploadStatus,
  origRowIndex
});
export const setDocumentReceivedSucess = (payload, isChecked,origRowIndex) => ({
  type: documentsTypes.MARK_DOCUMENT_READ,
  payload,
  isChecked,
  origRowIndex
});

export const setAcknowledgeDocument = (data, isChecked, origRowIndex) => {
  return async dispatch => {
    let { success } = await setAcknowledgeDocumentService({
      documentId: data[origRowIndex].documentId,
    });
    if (success) {
      dispatch(setAcknowledgeDocumentSucess(data, isChecked,origRowIndex));
    }
  };
};

export const setAcknowledgeDocumentSucess = (payload, isChecked,origRowIndex) => ({
  type: documentsTypes.ACKNOWLEDGE_DOCUMENT_READ,
  payload,
  isChecked,
  origRowIndex
});

export const startResumeButtonClick = params => {
  return async dispatch => {
    await startResumeButton(params);
  };
};

export default {
  setUploadStatus,
  getDocumentsSuccess,
  getSupportedFileTypesdocuments,
  getDocuments,
  getDocumentsFailure,
  toggleModal,
  getDocument,
  deleteDocument,
  getDocumentDetails,
  hideNotificationSuccess,
  getFilters,
  applyDocumentFilters,
  storeCaseManagerId,
  deHydrateDocumentDetails,
  openDocumentsTab,
  incrementDocCount,
  setDocumentReceived,
  getSlaDetails,
  getslalist,
  setMissingDocuments,
  setAllDocsReceivedByEY,
  getDownloadZipDocuments,
  getExecuteSPAPI,
  setAcknowledgeDocument,
  getlinkedCases,
  getlinkedCase,
  getDocumentFromGlobalMenu
};
